import styled from "styled-components";

export const EnterpriseMainDiv = styled.div`
  position: relative;
  background-color: black;
  color: white;
  min-height: 100vh;
`;

export const EnterpriseHeroSection = styled.div`
  text-align: center;
  padding: 150px 20px 80px;
  max-width: 1200px;
  margin: 0 auto;
  
  h1 {
    font-size: 64px;
    font-weight: 700;
    margin-bottom: 24px;
    background: linear-gradient(180deg, #FFFFFF 0%, #A1A1A1 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    
    @media (max-width: 768px) {
      font-size: 42px;
    }
  }

  p {
    font-size: 20px;
    color: #A1A1A1;
    max-width: 700px;
    margin: 0 auto 40px;
    line-height: 1.6;
    
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const PrimaryButton = styled.a`
  padding: 16px 32px;
  background: white;
  color: black;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid white;

  &:hover {
    background: transparent;
    color: white;
  }
`;

export const SecondaryButton = styled.a`
  padding: 16px 32px;
  background: transparent;
  color: white;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  border: 1px solid #333;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    border-color: white;
  }
`;

export const Section = styled.section`
  padding: 100px 20px;
  max-width: 1200px;
  margin: 0 auto;
  
  &.grey-bg {
    background: #0f0f0f;
    border-radius: 24px;
    margin: 40px auto;
    padding: 80px 40px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 42px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 60px;
  
  @media (max-width: 768px) {
    font-size: 32px;
    margin-bottom: 40px;
  }
`;

export const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FeatureCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 40px;
  border-radius: 16px;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.08);
  }

  h3 {
    font-size: 24px;
    margin: 20px 0 16px;
    font-weight: 600;
  }

  p {
    color: #A1A1A1;
    line-height: 1.6;
    font-size: 16px;
    margin: 0;
  }

  .icon-wrapper {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: white;
  }
`;

export const ContactSection = styled.div`
  text-align: center;
  padding: 100px 20px;
  background: linear-gradient(180deg, rgba(20,20,20,0) 0%, rgba(0, 0, 0, 0.1) 100%);
  
  h2 {
    font-size: 48px;
    margin-bottom: 24px;
    
    @media (max-width: 768px) {
      font-size: 36px;
    }
  }
  
  p {
    font-size: 20px;
    color: #A1A1A1;
    margin-bottom: 40px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
`;
